// Libreria para el uso de alertas
import Swal from 'sweetalert2';
import { store } from "../store/store";
// Se importan los types de cada acción para usar los que se requieran
import { types } from '../types/types';
import { loadProfile } from '../helpers/loadData'
// Función que permite limpiar la data del redux una vez se cierra sesión
import { startClean } from './admin';
import { startCleanDatesReserva } from './reservaperito';
import { startCleanDoctor } from './doctor';
import { startCleanDatesPatient } from './patient';
import { clearDashboard } from './dashboard';
import { getIP } from "./ui";
import { clearPermissionsUser } from './company';

// Método para iniciar sesión con usuario y contraseña
export const startLoginEmailPassword = (email, password) => {
	const reduxState = store.getState().company;
	const firebase = reduxState.companyInstance.firebase;

	return async () => {
		firebase.auth().signInWithEmailAndPassword(email, password)
			.then(({ user }) => {
				callInfoProfile(user.uid);

				getIP()
					.then(response => {
						enviarLogAuth(types.login, email, response.data, reduxState);
					})
			})
			.catch(e => {
				Swal.fire('Error', e.message, 'error');

				getIP()
					.then(response => {
						enviarLogErrorAuth(types.login, e.code, email, response.data);
					})
			})
	}
};

//Método para crear un usuario con correo y contraseña
export const signUpWithEmailPassword = (values) => {
	const reduxState = store.getState().company;
	const firebase = reduxState.companyInstance.firebase;
	const db = reduxState.companyInstance.db;
	const users = [];
	return async (dispatch) => {

		db.collection("users")
			.where("dni", "==", values.dni)
			.get()
			.then((querySnapshot) => {
				querySnapshot.forEach((doc) => {
					users.push({
						...doc.data()
					})
				});
				if (users.length === 0) {
					firebase.auth().createUserWithEmailAndPassword(values.email, values.password)
						.then(async ({ user }) => {

							addNewUserInfo(user.uid, values)

							getIP()
								.then(response => {
									enviarLogAuth(types.register, values.email, response.data, reduxState);
								})

							Swal.fire(
								'Excelente!',
								'Registro realizado con éxito!',
								'success'
							)
						}).catch(e => {
							Swal.fire('Error', e.message, 'error');

							getIP()
								.then(response => {
									enviarLogErrorAuth(types.register, e.code, values.email, response.data);
								})
						})
				} else {
					Swal.fire({
						icon: 'error',
						title: 'Error',
						text: 'Ya existe un Usuario registrado con este RUT'
					})
				}
			})
			.catch((error) => {
				Swal.fire({
					icon: 'error',
					title: 'Error',
					text: 'Problemas al realizar el Registro'
				})
			});
	}
};

//Método para agregar la información del usuario que se acaba de registrar en la aplicación
export const addNewUserInfo = (uid, values) => {
	const reduxState = store.getState().company;
	const db = reduxState.companyInstance.db;
	db.collection("users").doc(uid).set({
		address: values.address.toUpperCase().trim(),
		city: values.patientCity,
		cityId: values.patientCityId,
		civilState: values.civilState,
		codePhone: values.codePhone,
		contact: '',
		country: values.patientResidenceCountry,
		countryId: values.patientResidenceCountryId,
		createDate: new Date(),
		date: values.date,
		dni: values.dni,
		dniType: values.dniType,
		education: values.education,
		email: values.email,
		emailContact: '',
		gender: values.gender,
		imgProfile: '',
		lastnameFirst: values.lastnameFirst.toUpperCase().trim(),
		lastnameSecond: values.lastnameSecond.toUpperCase().trim(),
		medicalPlan: values.medicalPlan,
		mobile: false,
		nameFirst: values.nameFirst.toUpperCase().trim(),
		nameSecond: values.nameSecond.toUpperCase().trim(),
		nationality: values.nationality,
		numberContact: '',
		occupation: '',
		personPhoto: "",
		phone: values.phone,
		region: values.patientRegion,
		regionId: values.patientRegionId,
		signature: '',
		socialName: values.socialName.toUpperCase().trim(),
		state: true,
		terms: values.terms,
		typeUser: 'patient',
		uid,
	}).then(() => {
	}).catch((error) => {
		getIP()
			.then(response => {
				enviarLogErrorCreateUser(error, values.email, response.data);
			})
	});

};

//Método para agregar la información del usuario que se acaba de registrar en la aplicación desde el módulo de agendamiento
export const addNewUserInfoFromSchedule = (uid, values) => {
	const reduxState = store.getState().company;
	const db = reduxState.companyInstance.db;
	db.collection("users").doc(uid).set({
		userUid: uid,
		rut: values.rut,
		firstName: values.firstname,
		secondName: values.secondname,
		phone: values.phone,
		firstLastName: values.firstlastname,
		secondLastName: values.secondlastname,
		email: values.email,
		social_name: "",
		date: "",
		gender: "",
		country: "",
		nationality: "",
		address: "",
		region: "",
		commune: "",
		city: "",
		contact: "",
		number_contact: "",
		email_contact: "",
		education: "",
		occupation: "",
		medical_plan: "",
		civil_state: "",
		typeUser: "patient",
		imgProfile: "",
		terms: values.terms,
		state: true,
		firma_doctor: ""
	}).then(() => {
	}).catch((error) => {
		getIP()
			.then(response => {
				enviarLogErrorCreateUser(error, values.email, response.data);
			})
	});
};

//Método para crear usuario desde el modulo administrativo
export const addNewUserFromAdmin = (emailAdmin, uid, values) => {
	const reduxState = store.getState().company;
	const db = reduxState.companyInstance.db;
	return (dispatch) => {
		db.collection("users").doc(uid).set({
			city: "",
			cityId: "",
			civilState: "",
			codePhone: "",
			contact: "",
			country: values.country,
			countryId: values.countryId,
			createDate: new Date(),
			date: "",
			dni: values.dni,
			dniType: values.dniType,
			education: "",
			email: values.email,
			emailContact: "",
			gender: "",
			imgProfile: "",
			lastnameFirst: values.lastnameFirst.toUpperCase().trim(),
			lastnameSecond: values.lastnameSecond.toUpperCase().trim(),
			nameFirst: values.nameFirst.toUpperCase().trim(),
			nameSecond: values.nameSecond.toUpperCase().trim(),
			medicalPlan: "",
			mobile: "",
			nationality: "",
			address: "",
			numberContact: "",
			occupation: "",
			personPhoto: "",
			phone: "",
			region: "",
			regionId: "",
			signature: "",
			socialName: "",
			typeUser: values.type,
			terms: values.terms,
			state: true,
			permissions: values.permissions,
			uid,
		}).then(() => {
			alertOK("Usuario Creado con Éxito")
		}).catch((error) => {
			getIP()
				.then(response => {
					enviarLogErrorCreateUserFromAdmin(error, values.email, emailAdmin, response.data);
				})
		});
	}
}

//Método para recuperar la contraseña según el email
export const recoverPassword = (email) => {
	const reduxState = store.getState().company;
	const firebase = reduxState.companyInstance.firebase;
	const db = reduxState.companyInstance.db;
	return () => {
		firebase.auth().sendPasswordResetEmail(email)
			//Valida si el email de usuario se encuentra registrado y procede a realizar el envío de correo de recuperación
			.then(() => {
				Swal.fire(
					'Email de recuperacion enviado!',
					'Verifica tu correo electronico!',
					'success'
				)
				//Se busca el usuario con el Email en la colección users
				db.collection("users").where("email", "==", email).get()
					.then((querySnapshot) => {
						/* Si encuentra el usuario se procede a recorrer el documento para enviar al Log la acción y UID
						de la persona que solicita la recuperación de contraseña */
						querySnapshot.forEach((doc) => {
							getIP()
								.then(response => {
									enviarLogAuth(types.recover, email, response.data, reduxState);
								})
						});
					}).catch((error) => {
						getIP()
							.then(response => {
								enviarLogErrorAuth(types.recover, error, email, response.data);
							})
					});
			}).catch((error) => {
				Swal.fire('Usuario no encontrado', '', 'error');
				/* Si no se encuentra el usuario se procede a recorrer el documento para enviar al Log la acción y UID
				de la persona que solicita la recuperación de contraseña */
				getIP()
					.then(response => {
						enviarLogErrorAuth(types.recover, error.code, email, response.data);
					})
			});
	}
};

//Método para guardar las credenciales en el redux de quien inicia sesión
export const login = (uid, data) => {
	return (dispatch) => (
		//Realiza la acción que coincida con ese type y le envía el payload (data) que se almacenará en el redux
		dispatch(
			{
				type: data.typeUser === 'doctor' || data.typeUser === 'doctor-perito' ? types.loginDoctor : types.login,
				payload: {
					uid,
					data
				}
			}
		)
	)
};

//Método para guardar las credenciales en el redux de quien inicia sesión
export const loadDataProf = (data) => {
	return (dispatch) => (
		//Realiza la acción que coincida con ese type y le envía el payload (data) que se almacenará en el redux
		dispatch({
			type: types.loadDataProf,
			payload: { ...data }
		})
	)
};

//Método que permite cargar la información de quien inicia sesión
export const callInfoProfile = (uid, finished) => {
	return async (dispatch) => {
		loadProfile(uid, dispatch, finished);
	}
};

export const setPermissions = (permissions) => {
	return (dispatch) => (
		// Realiza la acción que coincida con ese type y le envía el payload (data) que se almacenará en el redux
		dispatch({
			type: types.loadPermissions, payload: permissions
		})
	)
};

//Método que permite cerrar sesión en firebase y seguidamente limpiar la data cargada en el redux
export const startLogout = (uid, typeUser, email) => {
	const reduxState = store.getState().company;
	const firebase = reduxState.companyInstance.firebase;
	return async (dispatch) => {
		await firebase.auth().signOut();

		getIP()
			.then(response => {
				dispatch(logout(uid, email, response.data, reduxState));
			})

		dispatch(startCleanDoctor());
		dispatch(startCleanDatesReserva());
		dispatch(startCleanDatesPatient());
		dispatch(clearDashboard());
		/*
			Se comenta para que no limpie los permisos que tiene la company y pueda realizar un login nuevamente 
			una vez vaya a acceder nuevamente sin necesidad de refrescar la ventana
			dispatch(clearPermissions())
		*/
		dispatch(clearPermissionsUser());
		dispatch(startClean());
	}
};

//Método que dispara el action de logout y envía al Log la acción y el id de la persona que la realiza
export const logout = (uid, email, IP, company) => {
	return (dispatch) => (
		dispatch(
			{
				type: types.logout
			}
		)
		// eslint-disable-next-line no-sequences
		,
		enviarLogAuth(types.logout, email, IP, { ...company })
	)
};

export const logoutPatientCall = () => {
	const reduxState = store.getState().company;
	const firebase = reduxState.companyInstance.firebase;
	return async (dispatch) => {
		await firebase.auth().signOut();
		dispatch({ type: types.logout })
	}
}

//Método para cambiar el state de true a false del usuario
export const changeState = async (uid) => {
	const reduxState = store.getState().company;
	const db = reduxState.companyInstance.db;
	let state_user = db.collection("users").doc(`${uid}`);

	try {
		await state_user.update({
			state: false
		})
	} catch (error) { }
};

/////////////////////////////////////////////////////MÉTODOS PARA LOGS/////////////////////////////////////////////////////
//Método para guardar el Log de Auth para iniciar sesión, cerrar sesión, olvidar contraseña y register
const enviarLogAuth = (action, email, IP, company) => {
	const reduxState = company;

	const db = reduxState.companyInstance.db;
	//Se crea la fecha actual en la que se crea el Log
	let date = new Date();
	//Se registra en la colección el Log, almacenando la fecha de la acción, la acción y el UID de la persona que la originó
	db.collection("log")
		.doc("logAuth")
		.collection("authLogout")
		.add({
			log_date: date,
			action: action,
			user: email,
			ip: IP.IPv4,
			country: IP.country_name
		});
};

//Método para guardar el Log de Auth para iniciar sesión, cerrar sesión, olvidar contraseña y register
export const enviarLogAuthPatient = (action, rut, IP) => {
	const reduxState = store.getState().company;
	const db = reduxState.companyInstance.db;
	//Se crea la fecha actual en la que se crea el Log
	let date = new Date();

	//Se registra en la colección el Log, almacenando la fecha de la acción, la acción y el UID de la persona que la originó
	db.collection("log")
		.add({
			log_date: date,
			action: action,
			patientRut: rut,
			ip: IP.IPv4,
			country: IP.country_name
		});
};

//Método para guardar el Log de los errores de Auth para iniciar sesión, cerrar sesión, olvidar contraseña y register
export const enviarLogErrorAuthPatient = (action, error, rut, IP) => {
	const reduxState = store.getState().company;
	const db = reduxState.companyInstance.db;
	//Se crea la fecha actual en la que se crea el Log
	let date = new Date();

	//Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido, el email con el que se intentó iniciar sesion, la IP y el País
	db.collection("log")
		.add({
			log_date: date,
			action: action,
			error: error,
			patientRut: rut,
			ip: IP.IPv4,
			country: IP.country_name
		});
}

//Método para guardar el Log de los errores de Auth para iniciar sesión, cerrar sesión, olvidar contraseña y register
const enviarLogErrorAuth = (action, error, email, IP) => {
	const reduxState = store.getState().company;
	const db = reduxState.companyInstance.db;
	//Se crea la fecha actual en la que se crea el Log
	let date = new Date();

	//Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido, el email con el que se intentó iniciar sesion, la IP y el País
	db.collection("log")
		.add({
			log_date: date,
			action: action,
			error: error,
			user: email,
			ip: IP.IPv4,
			country: IP.country_name
		});
}

//Método para guardar el Log de error al intentar guardar la data de un usuario nuevo
const enviarLogErrorCreateUser = (error, email, IP) => {
	const reduxState = store.getState().company;
	const db = reduxState.companyInstance.db;
	//Se crea la fecha actual en la que se crea el Log
	let date = new Date();

	//Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido, el email con el que se intentó iniciar sesion, la IP y el País
	db.collection("log")
		.add({
			log_date: date,
			action: '[Auth] Error Create User',
			error: error,
			user: email,
			ip: IP.IPv4,
			country: IP.country_name
		});
}

//Método para guardar el Log de error al intentar guardar la data de un usuario nuevo desde el admin
const enviarLogErrorCreateUserFromAdmin = (error, email, emailAdmin, IP) => {
	const reduxState = store.getState().company;
	const db = reduxState.companyInstance.db;
	//Se crea la fecha actual en la que se crea el Log
	let date = new Date();

	//Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido, el email con el que se intentó iniciar sesion, la IP y el País
	db.collection("log")
		.add({
			log_date: date,
			action: '[Auth] Error Create User',
			error: error,
			user: email,
			userAdmin: emailAdmin,
			ip: IP.IPv4,
			country: IP.country_name
		});
}
/////////////////////////////////////////////////////MÉTODOS PARA LOGS/////////////////////////////////////////////////////

/////////////////////////////////////////////////////MÉTODOS PARA ALERTAS/////////////////////////////////////////////////////
//Método para la alerta cuando fue con éxito una acción
const alertOK = (msg) => {
	Swal.fire({
		position: 'center',
		title: 'Excelente!',
		text: msg,
		icon: 'success',
	})
}

//Método para la alerta cuando fracasó una acción
export const alertFAIL = (msg) => {
	Swal.fire({
		icon: 'error',
		title: 'Error',
		text: msg,
	})
}
/////////////////////////////////////////////////////MÉTODOS PARA ALERTAS/////////////////////////////////////////////////////

